export default class MapLayerIndex {
  public idMapLayer: number = 0;
  public index: number = 0;
}
